import { useEffect, useRef, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { Corners, GlowButton, Tag } from "@/components/ui-kit";

const STEPS = [
  "REQUEST CREATED",
  "AGENT VERIFIED",
  "SERVICE DISCOVERED",
  "PAYMENT AUTHORIZED",
  "TASK EXECUTED",
  "SETTLEMENT COMPLETE",
];

const PaymentDemo = () => {
  const [step, setStep] = useState(-1);
  const [running, setRunning] = useState(false);
  const timer = useRef(null);

  const run = () => {
    if (running) return;
    setRunning(true);
    setStep(0);
    let i = 0;
    timer.current = setInterval(() => {
      i += 1;
      setStep(i);
      if (i >= STEPS.length - 1) {
        clearInterval(timer.current);
        setRunning(false);
      }
    }, 650);
  };

  useEffect(() => () => clearInterval(timer.current), []);
  const settled = step === STEPS.length - 1 && !running;

  return (
    <div data-testid="payment-demo" className="hud-panel relative p-6">
      <Corners />
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] text-arc-electric mb-1">MACHINE-TO-MACHINE PAYMENT</div>
          <div className="font-display text-xl font-bold text-arc-white">ROVER-017 <span className="text-arc-silver/40 font-normal">requests</span> MAPPING SERVICE</div>
        </div>
        <div className="text-right">
          <div className="font-mono text-[10px] tracking-[0.3em] text-arc-silver/40">PRICE</div>
          <div className="font-mono text-2xl text-arc-cyan">0.12 <span className="text-sm">USDC</span></div>
        </div>
      </div>
      <div className="space-y-2 mb-6">
        {STEPS.map((s, i) => (
          <div key={s} className={`flex items-center gap-3 font-mono text-xs tracking-[0.15em] px-3 py-2 border transition-colors duration-300 ${
            i <= step ? "border-arc-electric/40 bg-arc-blue/5 text-arc-silver" : "border-arc-silver/10 text-arc-silver/30"
          }`}>
            <span className="w-4 h-4 flex items-center justify-center">
              {i < step || settled ? (
                <Check size={13} className="text-arc-green" />
              ) : i === step && running ? (
                <Loader2 size={13} className="text-arc-cyan animate-spin" />
              ) : (
                <span className="w-1.5 h-1.5 border border-arc-silver/30" />
              )}
            </span>
            <span>{String(i + 1).padStart(2, "0")} · {s}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <GlowButton onClick={run} testId="execute-simulation-button" cursor="TARGET">
          {settled ? "RUN AGAIN" : running ? "EXECUTING..." : "EXECUTE SIMULATION"}
        </GlowButton>
        {settled && (
          <div className="flex gap-4 font-mono text-[11px] tracking-[0.2em]">
            <span className="text-arc-silver/50">NETWORK <span className="text-arc-silver ml-1">ARC</span></span>
            <span className="text-arc-silver/50">ASSET <span className="text-arc-silver ml-1">USDC</span></span>
            <span className="text-arc-silver/50">STATUS <span className="text-arc-green ml-1">SETTLED</span></span>
          </div>
        )}
      </div>
      <div className="mt-5"><Tag tone="amber">INTERACTIVE CONCEPT DEMO — NO REAL TRANSACTION IS EXECUTED</Tag></div>
    </div>
  );
};

export default PaymentDemo;
